import React from 'react';
import { colors, typography } from '../theme';
/**
 * Brand logo: "cool·tools" – "cool" in primary blue, "tools" in accent cyan.
 * The middot separator uses a slightly muted color to keep it lightweight.
 */
export const Logo = ({ size = typography.fontSizeLg }) => {
    return (React.createElement("span", { style: {
            fontFamily: typography.fontFamily,
            fontSize: size,
            fontWeight: 700,
            letterSpacing: '-0.01em',
            userSelect: 'none',
        }, "aria-label": "cool-tools" },
        React.createElement("span", { style: { color: colors.primary } }, "cool"),
        React.createElement("span", { style: { color: colors.textMuted, fontWeight: 400 } }, "\u00B7"),
        React.createElement("span", { style: { color: colors.accent } }, "tools")));
};
